import React, { PureComponent } from 'react'
import { ProgressCircle } from 'react-native-svg-charts'

export default class Donut extends PureComponent {
  render () {
    const { backgroundColour, colour, height = 200, min, max, value, stroke = 11 } = this.props
    let _progress = 0
    let _progressColor = colour
    let _backgroundColor = backgroundColour
    if (value > 0) {
      _progress = value / max * 0.5
    }
    if (value < 0) {
      _progress = 1 - (value / min * 0.5)
      _progressColor = backgroundColour
      _backgroundColor = colour
    }
    return (
      <ProgressCircle
        style={{ height, width: height }}
        progress={_progress}
        progressColor={_progressColor}
        backgroundColor={_backgroundColor}
        cornerRadius={0}
        strokeWidth={stroke}
      />
    )
  }
}
